var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-menu-item",on:{"click":function($event){return _vm.handleClick()}}},[_c('img',{attrs:{"width":"","src":require(`../../assets/icons/${_vm.icon}.png`)}}),_c('p',{staticClass:"small-text side-menu-item-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }